import React from 'react';

import { STATUS } from '../../../../../constants/statuses';
import { CHAT_ROLE } from '../../../../../constants/assistant';

import { useResponsiveBreakpoints } from '../../../../../hooks/useResponsiveBreakpoints';

import ToolTip from '../../../../../design-system/ToolTip/ToolTip';
import RichTextArea from '../../../../../design-system/RichTextArea/RichTextArea';
import ContentLoader from '../../../../AssistantPage/ContentLoader/ContentLoader';
import RefreshCwIcon from '../../../../../design-system/Icons/RefreshCwIcon';
import MessageWrapper from '../../../../AssistantPage/MessageWrapper/MessageWrapper';
import MessageErrorBanner from '../../../../AssistantPage/MessageErrorBanner/MessageErrorBanner';
import CustomBotMessageHeader from '../../../../AssistantPage/CustomBotMessageHeader/CustomBotMessageHeader';
import { ButtonIcon } from '../../../../../design-system';

const ApiResponse = ({ message, handleRegenerate, isRegenerateDisabled = false }) => {
    const { status, response, customBot } = message;

    const { isDesktop } = useResponsiveBreakpoints();

    const isLoading = status === STATUS.pending;
    const isCompleted = status === STATUS.success;
    const isError = status === STATUS.failure;

    const value = '```json\n' + JSON.stringify(response, null, 2) + '\n```';

    return (
        <MessageWrapper role={CHAT_ROLE.assistant} blackRobotIcon isSimplifiedVersion>
            <CustomBotMessageHeader customBotName={customBot.name} />

            <div className="flex flex-col gap-4">
                {isLoading && <ContentLoader />}

                {isCompleted && (
                    <>
                        <RichTextArea
                            value={value}
                            previewOnly
                            autoExpand
                            isBorderHidden
                            previewCustomClassName="code-white-background"
                        />

                        <ToolTip
                            text="Regenerate"
                            position="top-left"
                            shift="-2px"
                            isShown={false}
                            useInternalHoverStateToShowToolTip={isDesktop}
                        >
                            <ButtonIcon
                                type="neutral"
                                size="xs"
                                icon={RefreshCwIcon}
                                state={isRegenerateDisabled ? 'disabled' : 'default'}
                                onClick={handleRegenerate}
                            />
                        </ToolTip>
                    </>
                )}

                {isError && (
                    <MessageErrorBanner
                        handleRegenerate={handleRegenerate}
                        isDisabled={isRegenerateDisabled}
                    />
                )}
            </div>
        </MessageWrapper>
    );
};

export default ApiResponse;
